import React from "react";
import axios from "axios";
import { Button, FormGroup, Label, Input } from "reactstrap";

const UploadImages = () => {
  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();

    formData.append("code", event.target.code.value);
    formData.append(
      "image_last_updated_date",
      event.target.actual_installations_date.value
    );

    if (event.target.image.files.length > 0) {
      formData.append("image", event.target.image.files[0]);
    }

    if (event.target.image1.files.length > 0) {
      formData.append("image1", event.target.image1.files[0]);
    }

    if (event.target.image2.files.length > 0) {
      formData.append("image2", event.target.image2.files[0]);
    }

    if (event.target.image3.files.length > 0) {
      formData.append("image3", event.target.image3.files[0]);
    }

    if (event.target.image4.files.length > 0) {
      formData.append("image4", event.target.image4.files[0]);
    }

    try {
      const response = await axios.post(
        "https://api.outdoorooh.com/api/update-image-with-history",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);
      alert("Data uploaded successfully");

      event.target.reset();
    } catch (error) {
      console.log(error.response?.data || error);
      alert(error.response?.data?.message || "Upload Failed");
    }
  };

  return (
    <div className="container mt-4">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <FormGroup>
          <Label>Site Code</Label>
          <Input
            type="text"
            name="code"
            placeholder="Enter Site Code"
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>Image Last Updated Date</Label>
          <Input
            type="datetime-local"
            name="actual_installations_date"
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>Main Image</Label>
          <Input type="file" name="image" />
        </FormGroup>

        <FormGroup>
          <Label>Image 1</Label>
          <Input type="file" name="image1" />
        </FormGroup>

        <FormGroup>
          <Label>Image 2</Label>
          <Input type="file" name="image2" />
        </FormGroup>

        <FormGroup>
          <Label>Image 3</Label>
          <Input type="file" name="image3" />
        </FormGroup>

        <FormGroup>
          <Label>Image 4</Label>
          <Input type="file" name="image4" />
        </FormGroup>

        <Button color="primary" type="submit">
          Upload
        </Button>
      </form>
    </div>
  );
};

export default UploadImages;